var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24765 11.0796L5.24789 11.0799C5.50002 11.348 5.8519 11.4999 6.21965 11.4999L6.22548 11.4999L6.22908 11.4999C6.59912 11.4972 6.95382 11.3405 7.20427 11.0649C7.20447 11.0647 7.20467 11.0645 7.20486 11.0643L14.8179 2.73222C14.8179 2.7322 14.8179 2.73218 14.8179 2.73216C15.3139 2.18946 15.2769 1.34571 14.7336 0.849158L14.7332 0.848746C14.19 0.353487 13.3474 0.389075 12.849 0.934145L12.8489 0.934287L6.20623 8.20421L3.13853 4.93869C3.13846 4.93862 3.1384 4.93856 3.13834 4.93849C3.1383 4.93845 3.13827 4.93842 3.13823 4.93838C2.63463 4.40172 1.79087 4.37604 1.25425 4.87937L1.2538 4.8798C0.718714 5.38294 0.689343 6.22687 1.19546 6.76414C1.19559 6.76428 1.19571 6.76441 1.19584 6.76455L5.24765 11.0796Z",
    fill: "#51CF66",
    stroke: "#51CF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.a0988bbfe9588aad312eb4ac815fdb60.svg";
export { ForwardRef as ReactComponent };